<h6 class="content-header">Audit more posts</h6>
<div class="card">
  <div class="card-body post-report">
    <div class="text-center mt-3 mb-5" *ngIf="type() == 2 && (postState | async).postDetail !== null">
      <h3>Would you like to audit more post of &#64;{{(postState | async).postDetail.profile.username}}?</h3>
    </div>
    <div class="row" *ngIf="(profileState | async).profileMedia !== null">
      <div class="col-xs-12 col-sm-6 col-lg-4 post-audit post-analyze"
           *ngFor="let post of (profileState | async).profileMedia">
        <div class="row">
              <div class="col-md-6">
                <p class="post-text">{{post.caption}}</p>
                <p class="date">{{(post.date * 1000) | date}}</p>
              </div>
              <div class="col-md-6 text-center">
                <a href="{{'https://www.instagram.com/p/' + post.code}}" target="_blank">
                  <img width="200" class="post-image rounded-sm" [src]="post.thumbnail_src">
                </a>
                <div class="info">
                  <span>
                    <img class="post-icon" src="assets/images/icons/heart.png"/>
                    <span>{{post.like_count | shortcutNumbers}}</span>
                  </span>
                  <span>
                    <img class="post-icon" src="assets/images/icons/comment.png"/>
                    <span>{{post.comment_count | shortcutNumbers}}</span>
                  </span>
                </div>
              </div>
              <div class="col-12 text-center mt-3">
                <a class="btn btn-light" (click)="addPostAudit(post.code)">Analyze this post</a>
              </div>
            </div>
        </div>
      </div>
  </div>
</div>
